/* eslint object-curly-newline: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    navigation: {
      title: 'Element Smart Parking',
      rightElements: [],
      backUrl: null,
      tabs: null,
    },
  },
  mutations: {
    SET_NAV_TITLE(state, title) {
      state.navigation.title = title;
    },
    SET_NAV_RIGHT_ELEMENTS(state, elements) {
      state.navigation.rightElements = elements;
    },
    SET_NAV_BACK_URL(state, backUrl) {
      state.navigation.backUrl = backUrl;
    },
    SET_TABS(state, tabs) {
      state.navigation.tabs = tabs;
    },
  },
});
